///<reference path="../../employee/sections/employee.deduction.section.ts"/>
module Meevo.Plugins.Teachers {
    'use strict';

    export class DeductionSection extends Meevo.Plugins.Employee.DeductionSection {

        get auditNounForSave(): Model.NounEnum {
            return Model.NounEnum.TeacherDeduction;
        }
    }
}